import { moment } from "@/utils/useTimeZone";

// Returns an error message (dates shown in site time) if the discount code is not yet
// valid or has expired as of referenceDate (defaults to now), otherwise undefined.
export const getDiscountCodeValidationError = (
  discountCode: Record<string, any>,
  referenceDate?: string | Date
): string | undefined => {
  const referenceMoment = referenceDate ? moment(referenceDate) : moment();

  if (discountCode?.validFrom && referenceMoment.isBefore(moment(discountCode.validFrom))) {
    return `This discount code is not valid until ${moment(discountCode.validFrom).format("DD/MM/YYYY")}`;
  }

  if (discountCode?.expiry && referenceMoment.isAfter(moment(discountCode.expiry).endOf("day"))) {
    return "This discount code has expired";
  }

  return undefined;
};
